<template>
<div class="chapter">
<div class="inner_page">
<p class="OT"><a id="page_v">Contents</a></p><a id="page_v">
</a><p class="TocSb1" id="for1"><a id="page_v"></a><a href="#/xhtml/Foreword#for"><i>Foreword</i> by Rick Warren</a></p>
<p class="Toc1" id="pre1"><a href="#/xhtml/Preface001#pre"><i>Preface to the Third Edition</i></a></p>
<p class="Toc1" id="pref1"><a href="#/xhtml/Preface002#pref"><i>Preface</i></a></p>
<p class="Toc" id="ch-001"><a href="#/xhtml/Chapter001#ch001">1.<span class="space05">The Right Approach</span></a></p>
<p class="Toc-pt" id="pt1"><span href="#/xhtml/Part001#pt" title="Link target outside of Sample"><span class="small">PART ONE</span></span></p>
<p class="Toc-pt1"><span href="#/xhtml/Part001#pt" title="Link target outside of Sample">Who Christ Is</span></p>
<p class="Toc" id="ch-002"><span href="#/xhtml/Chapter002#ch002" title="Link target outside of Sample">2.<span class="space05">The Claims of Christ</span></span></p>
<p class="Toc" id="ch-003"><span href="#/xhtml/Chapter003#ch003" title="Link target outside of Sample">3.<span class="space05">The Character of Christ</span></span></p>
<p class="Toc" id="ch-004"><span href="#/xhtml/Chapter004#ch004" title="Link target outside of Sample">4.<span class="space05">The Resurrection of Christ</span></span></p>
<p class="Toc-pt" id="pat1"><span href="#/xhtml/Part002#pat" title="Link target outside of Sample"><span class="small">PART TWO</span></span></p>
<p class="Toc-pt1"><span href="#/xhtml/Part002#pat" title="Link target outside of Sample">What We Need</span></p>
<p class="Toc" id="ch-005"><span href="#/xhtml/Chapter005#ch005" title="Link target outside of Sample">5.<span class="space05">The Fact and Nature of Sin</span></span></p>
<p class="Toc" id="ch-006"><span href="#/xhtml/Chapter006#ch006" title="Link target outside of Sample">6.<span class="space05">The Consequences of Sin</span></span></p>
<p class="Toc-pt" id="pt3_1"><span href="#/xhtml/Part003#pt3" title="Link target outside of Sample"><span class="small">PART THREE</span></span></p>
<p class="Toc-pt1"><span href="#/xhtml/Part003#pt3" title="Link target outside of Sample">What Christ Has Done</span></p>
<p class="Toc" id="ch-007"><span href="#/xhtml/Chapter007#ch007" title="Link target outside of Sample">7.<span class="space05">The Death of Christ</span></span></p>
<p class="Toc" id="ch-008"><span href="#/xhtml/Chapter008#ch008" title="Link target outside of Sample">8.<span class="space05">The Salvation of Christ</span></span></p>
<p class="Toc-pt" id="pt4_1"><a id="page_vi"></a><span href="#/xhtml/Part004#pt4" title="Link target outside of Sample"><span class="small">PART FOUR</span></span></p>
<p class="Toc-pt1"><span href="#/xhtml/Part004#pt4" title="Link target outside of Sample">How to Respond</span></p>
<p class="Toc" id="ch-009"><span href="#/xhtml/Chapter009#ch009" title="Link target outside of Sample">9.<span class="space05">Counting the Cost</span></span></p>
<p class="Toc2" id="ch-010"><span href="#/xhtml/Chapter010#ch010" title="Link target outside of Sample">10.<span class="space05">Reaching a Decision</span></span></p>
<p class="Toc2" id="ch-011"><span href="#/xhtml/Chapter011#ch011" title="Link target outside of Sample">11.<span class="space05">Being a Christian</span></span></p>
<p class="Toc1" id="que1"><span href="#/xhtml/Questions#que" title="Link target outside of Sample"><i>Study Questions</i></span></p>
<p class="Toc1" id="ind1"><span href="#/xhtml/Index#ind" title="Link target outside of Sample"><i>Scripture Index</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?5238bb63